import { stackOrderReverse } from "d3"
import PostService from "./post_service"

const _ = require("lodash")
const d3 = require("d3")
const echarts = require("echarts/lib/echarts")
import dists  from '../../public/data/india_districts.json'
import states from '../../public/data/india_states.json'

import { downloadTSV } from '@/scripts/utils.js'

const store = {
  debug: true,
  loading: true,
  events: {
    trigger: 0,
  },
  settings: {
    // activeIndex: "1",
    showDraw: false,
    showTips: true,
    allowedRoutes: ["Home", "Variants"],    
    cladeTimeLinePlotType: "Scatter",
    sortIcons: {
      none: "fas icon-fa-sort",
      asc: "fas icon-fa-sort-up",
      desc: "fas icon-fa-sort-down",
    },
    sortMap: { none: "asc", asc: "desc", desc: "none" }
  },
  theme: {
    fontFamily: {
      content: "Manrope, Helvetica, Arial, sans-serif",
      header: "Hammersmith One, sans-serif",
      plotTooltip: "Ubuntu, sans-serif",
    },
    viewMode: {
      active: "light",
      change: function() {
        if (store.theme.viewMode.active === "light") {
          store.theme.viewMode.active = "dark"
        } else {
          store.theme.viewMode.active = "light"
        }
      },
      icons: { dark: "fas icon-fa-sun", light: "fas icon-fa-moon" },
      tooltip: { light: "Dark Mode", dark: "Light Mode" },
      backgroundColor: { light: "#ffffff", dark: "#2e2e2e" },
      iconColor: { light: "#ffffff", dark: "#2e2e2e" },
      textColor: { dark: "#ffffff", light: "#2e2e2e" },
      tooltipBackgroundColor: { light: "rgba(0, 0, 0, 0.5)", dark: "rgba(255, 255, 255, 0.5)" },
      iconBackgroundColor: { dark: "#ffffff", light: "#2e2e2e" },
      tableBorder: { dark: "#c1c1c1", light: "#ffffff" },
      axisColor: { dark: '#b9b9b9', light: '#4e4e4e' }
    },
    colors: {
      palettes: {
        okabe_lto:  [ "#E99C2B", "#49B3E6", "#009D75", "#F3E357", "#0072AE", "#D85B1C", "#CC77A4" ],
        tol_bright: [ "#F16376", "#24883E", "#3E77A6", "#CEB952", "#5BCCEC", "#AB3274", "#BABABA" ],
        tol_muted:  [ "#81CBEC", "#3FA998", "#11773B", "#302784", "#DFCB7D", "#9A9840", "#CE6476", "#892354", "#AA4395", "#DCDCDC" ],
        tol_light: [ "#BCCB49", "#ABA92C", "#70A9DA", "#F18569", "#F0DC8D", "#FFA7B9", "#91DDFD", "#3EBB99", "#DCDCDC" ],
        lineage_colors: [ 
          "#EFD31A", "#E4B7D5", "#F4AE1A", "#8B8BC3", "#F36B28", "#94CAE3", "#EF4924", "#A0D9D9", "#F38193", "#97D1A9", "#EC468B", "#CAE089",
          "#F7E49A", "#B856A1", "#FECE79", "#915BA6", "#F8A656", "#518BC9", "#F48170", "#27BEB6", "#EE2F44", "#67BF6B", "#F391BC", "#A1CD49",
        ]
      },
      clades: {
        A1a: "#5F4690",
        A2: "#1D6996",
        A2a: "#38A6A5",
        A3:  "#0F8554",
        "I/A3i": "#73AF48",
        A6: "#EDAD08",
        A7: "#E17C05",
        B: "#CC503E",
        B1: "#94346E",
        B2: "#6F4070",
        B4: "#994E95",
        Unassigned: "#666666"
      },
      nextstrain_clades : {
        "19A": "#4F34D2",
        "19B": "#4664EB",
        "20A": "#4E91E5",
        "20B": "#5FB2CA",
        "20C": "#77C7A4",
        "20D": "#94D37F",
        "20E (EU1)": "#B8D763",
        "20F": "#DBD350",
        "20G": "#F6C445",
        "20H/501Y.V2": "#FFA43D",
        "20I/501Y.V1": "#FF7034",
        "20J/501Y.V2": "#F93529",
        "Unassigned": "#767676",
      },
      nextstrain_clades_default : {
        "19A": "#4F34D2",
        "19B": "#4664EB",
        "20A": "#4E91E5",
        "20B": "#5FB2CA",
        "20C": "#77C7A4",
        "20D": "#94D37F",
        "20E (EU1)": "#B8D763",
        "20F": "#DBD350",
        "20G": "#F6C445",
        "20H/501Y.V2": "#FFA43D",
        "20I/501Y.V1": "#FF7034",
        "20J/501Y.V2": "#F93529",
        "Unassigned": "#767676",
      },
      cladesDefault: {
        A1a: "#6C27AD", // "#4A7BE9", 
        A2: "#5EAECE",  // "#3333FF", 
        A2a: "#4974EB", // "#66BAC1", 
        A3:  "#BCD760", // "#96D37E",
        "I/A3i": "#0DB07F", // "#957DAD"
        A6: "#AAD66D",
        A7: "#D1D555",
        B: "#F0C947", // "#D4D553",
        B1: "#F16533", // "#EB5733",
        B2: "#FF7535",
        B4: "#F93529", // "#F5B13F", 
        Unassigned: "#aaaaaa"
      },
      cladesMono: {
        A1a: "#1c4f57",
        A2: "#3b6a7b",
        A2a: "#993737",
        A3:  "#b25264",
        "I/A3i": "#5f859f",
        A6: "#c47191",
        A7: "#89a0c2",
        B: "#d192ba",
        B1: "#b6bbe2",
        B2: "#dcb4df",
        B4: "#e7d6ff",
        Unassigned: "#aaaaaa"
      },
      pangolin_lineages: {},
      gender: {
        Female: "#5A9D2D",
        Male: "#3F63AB",
        Unknown: "#999999"
      }
    },
  },
  render: {
    methods: {
      loadMainNavBar()     { store.render.MainNavBar = true },
      loadVariantFrequency() { store.render.VariantFrequency = true },
      loadVariantTimeline() { store.render.VariantTimeline = true },
      loadVariantsTable() { store.render.VariantsTable = true },
      loadComponent(component) { store.render[component] = true  },
      destroyHomepage() {
        store.render.NumGenomesStat = false
        store.render.NumVariantsStat = false
        store.render.NumCladesStat = false
        store.render.NumStatesStat = false
        store.render.NumLabsStat = false
        store.render.HomeHelpContent = false
        store.render.HomeLatestVariants = false
        store.render.HomeSampleDemographics = false
        store.render.HomeStateContributions = false
        store.render.HomeCladeDistributionTimeline = false
      },
      variantSwitchView(val) {
        if (val === "Timeline") {
          store.render.VariantTimeline = true
          store.render.VariantsTable = false
        } else {
          store.render.VariantTimeline = false
          store.render.VariantsTable = true
        }
      },
    },
    delayFactor: 500,
    MainNavBar: false,
    NumGenomesStat: false,
    NumVariantsStat: false,
    NumCladesStat: false,
    NumStatesStat: false,
    NumLabsStat: false,
    HomeHelpContent: false,
    HomeLatestVariants: false,
    HomeSampleDemographics: false,
    HomeStateContributions: false,

    GenomesMetadataTable: false,
    GenomesGeomapTimeline: false,
    GenomesSampleDemographics: false,
    GenomesPageCladeTimeline: false,
    
    VariantFrequency: false,
    VariantTimeline: false,
    VariantsTable: false,

    Homepage: false,
    HomeDateRangePicker: false,
    HomeRecentGenomesStateDistribution: false,
    HomeRecentGenomesSampleDemographics: false,
    HomePangolinLineageSelect: false,
    HomeCladeDistributionTimeline: false,
    HomeRecentGenomesVOCStats: false,

    SituationCladeMovingAverageTimeline: false,
    SituationPangolinLineageSelect: false,
  },
  maps: {
    india: {
      states: {},
      districts: {}
    },
    loaded: false
  },
  constants: {
    lastUpdated: "28th Jun, 2022",
    genomeSize: 0,
    clades: [],
    pangolinLineages: [],
    pangolinLineageCounts: [],
    cladeCounts: [],
    genders: [],
    numSamples: 0,
    numVariants: 0,
    numStates: 0,
    stateCounts: [],
    dateRange: [0, 0],
    minAge: 0, maxAge: 0,
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    monthDays: [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    indianStates: [{
        "name": "Andhra Pradesh",
        "code": "AP"
      },
      {
        "name": "Arunachal Pradesh",
        "code": "AR"
      },
      {
        "name": "Assam",
        "code": "AS"
      },
      {
        "name": "Bihar",
        "code": "BR"
      },
      {
        "name": "Chhattisgarh",
        "code": "CG"
      },
      {
        "name": "Goa",
        "code": "GA"
      },
      {
        "name": "Gujarat",
        "code": "GJ"
      },
      {
        "name": "Haryana",
        "code": "HR"
      },
      {
        "name": "Himachal Pradesh",
        "code": "HP"
      },
      {
        "name": "Jammu and Kashmir",
        "code": "JK"
      },
      {
        "name": "Jharkhand",
        "code": "JH"
      },
      {
        "name": "Karnataka",
        "code": "KA"
      },
      {
        "name": "Kerala",
        "code": "KL"
      },
      {
        "name": "Madhya Pradesh",
        "code": "MP"
      },
      {
        "name": "Maharashtra",
        "code": "MH"
      },
      {
        "name": "Manipur",
        "code": "MN"
      },
      {
        "name": "Meghalaya",
        "code": "ML"
      },
      {
        "name": "Mizoram",
        "code": "MZ"
      },
      {
        "name": "Nagaland",
        "code": "NL"
      },
      {
        "name": "Odisha",
        "code": "OR"
      },
      {
        "name": "Punjab",
        "code": "PB"
      },
      {
        "name": "Rajasthan",
        "code": "RJ"
      },
      {
        "name": "Sikkim",
        "code": "SK"
      },
      {
        "name": "Tamil Nadu",
        "code": "TN"
      },
      {
        "name": "Telangana",
        "code": "TS"
      },
      {
        "name": "Tripura",
        "code": "TR"
      },
      {
        "name": "Uttar Pradesh",
        "code": "UP"
      },
      {
        "name": "Uttarakhand",
        "code": "UK"
      },
      {
        "name": "West Bengal",
        "code": "WB"
      },
      {
        "name": "Andaman and Nicobar Islands",
        "code": "AN"
      },
      {
        "name": "Chandigarh",
        "code": "CH"
      },
      {
        "name": "Dadra and Nagar Haveli and Daman and Diu",
        "code": "DD"
      },
      {
        "name": "Delhi",
        "code": "DL"
      },
      {
        "name": "Ladakh",
        "code": "LA"
      },
      {
        "name": "Lakshadweep",
        "code": "LD"
      },
      {
        "name": "Puducherry",
        "code": "PY"
      },
      {
        "name": "Unknown",
        "code": "XX"
      },
    ],
    countryCodes: {
      "India": "IN",
      "US": "US",
      "Hong Kong": "HK",
      "Belgium": "BE",
      "Ecuador": "EC",
      "South Korea": "KR",
      "Netherlands": "NL",
      "Qatar": "QA",
      "Brazil": "BR",
      "France": "FR"
    },
    importantVariants: [
      {
        "position": 22882,
        "ref": "T",
        "alt": "G",
        "gene": "S:440",
        "aaVar": "N440K",
      },
      {
        "position": 23063,
        "ref": "A",
        "alt": "T",
        "gene": "S:501",
        "aaVar": "N501Y"
      },
      {
        "position": 23012,
        "ref": "G",
        "alt": "A",
        "gene": "S:484",
        "aaVar": "E484K"
      },
      {
        "position": 21974,
        "ref": "G",
        "alt": "T",
        "gene": "S:138",
        "aaVar": "D138Y",
      }
    ]
  },
  datasets: {
    metadata: [],
    variants: [],
    reinfection: [],
    genomeFeatures: [],
    importantVariants: [],
    indiaGeomapTimeline: [],
    topPangolinLineages: [],
    labs: [],
    selectedPangolinLineages: [],
  },
  tips: [
    "Click on the info icon next to the plot titles for detailed explanation of plots",
    "Use the settings pane on the right side to customize the colors for clades and states",
    "If this is the first time you are using this site, go through the About and Help pages for better understanding of the site\"s functionality"
  ],
  methods: {

    windowDates: function(date, gap) {
      const day = parseInt(date.split('-')[2])
      const month = parseInt(date.split('-')[1])
      const year = parseInt(date.split('-')[0])
      
      let pastGapDay = day - gap
      let futureGapDay = day + gap
      let pastGapMonth = month
      let futureGapMonth = month
      let pastGapYear = year
      let futureGapYear = year
      if (futureGapDay > store.constants.monthDays[month-1]) {
        if (month == 12) {
          futureGapYear += 1
          futureGapMonth = 1
          futureGapDay -= store.constants.monthDays[11]
        }
        else {
          futureGapMonth += 1
          futureGapDay -= store.constants.monthDays[month-1]
        }
      }

      if (pastGapDay <= 0) {
        if (month == 1) {
          pastGapYear -= 1
          pastGapMonth = 12
          pastGapDay = 31 + pastGapDay
        }
        else {
          pastGapMonth -= 1
          pastGapDay = store.constants.monthDays[month-1] + pastGapDay
        }
      }
      
      return [
              `${pastGapYear}-${String(pastGapMonth).padStart(2, '0')}-${String(pastGapDay).padStart(2, '0')}`,
              `${futureGapYear}-${String(futureGapMonth).padStart(2, '0')}-${String(futureGapDay).padStart(2, '0')}`
             ]
    },

    loadGenomeData: function (caller) {
      if (store.debug) {
        console.log(`${caller}`)
      }

      d3.tsv("./data/SARS-COV2_maingenelocations.bed").then(data => {
        store.datasets.genomeFeatures = data
        const genomeSize = _.max(_.map(data, d => {
          return parseInt(d.stop)
        }))
        store.constants.genomeSize = genomeSize
        store.mutationComponent.tableFilters.endPosition = genomeSize
      })
    },

    loadDistrictMapData: function (caller) {
      if (store.debug) {
        console.log(`${caller}`)
      }

      // d3.json("./data/india_districts.json").then(data => {
      //   data.features = _.map(data.features, d => {
      //     d.properties.name = d.properties.district;
      //     return d;
      //   })
      //   store.maps.india.districts = data;
      // })

      // d3.json("./data/india_districts.json").then(data => {
        dists.features = _.map(dists.features, d => {
          d.properties.name = d.properties.district;
          return d;
        })
        store.maps.india.districts = dists;
      // })
    },

    loadStateMapData: function (caller) {
      if (store.debug) {
        console.log(`${caller}`)
      }

      // d3.json("./data/india_districts.json").then(data => {
        states.features = _.map(states.features, d => {
          const cx = _.mean(_.map(d.geometry.coordinates, c => {
            return parseFloat(c[0])
          }))
          const cy = _.mean(_.map(d.geometry.coordinates, c => {
            return parseFloat(c[1])
          }))
          d.properties.center = [cx, cy]
          d.properties.name = d.properties.st_nm;
          return d;
        })
        store.maps.india.states = states;
        store.maps.loaded = true
      // })
    },

    loadReinfectionData: function(caller) {
      if (store.debug) {
        console.log(caller)
      }

      d3.tsv("./data/reinfection_data.tsv").then(data => {
        store.datasets.reinfection = _.map(data, d => {
          d.Interval = parseInt(d.Interval)
          return d;
        })
      })
    },

    loadGlobalDatasets: async function() {
      if (store.debug) {
        console.log("Loading Global Datasets!")
      }

      let today = new Date();
      let dd = String(today.getDate()).padStart(2, '0');
      let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      let yyyy = today.getFullYear();

      today = `${yyyy}-${mm}-${dd}`

      const numSamples = await PostService.getStat("samples")
      store.constants.numSamples = numSamples[0]["numSamples"]
      
      const numVariants = await PostService.getStat("variants")
      store.constants.numVariants = numVariants[0]["numVariants"]
      
      const indianStates = _.map(store.constants.indianStates, "name")
      store.constants.stateCounts = await PostService.getStat("states")

      console.log('State Counts: ', store.constants.stateCounts)
      
      let numStates = 0
      store.constants.stateCounts.forEach(s => { if (indianStates.indexOf(s.state) > -1) numStates += 1 })
      store.constants.numStates = numStates

      store.constants.topPangolinLineagesCounts = await PostService.getSituationData({
        plot: "topPangolinLineagesCounts"
      })

      store.datasets.topPangolinLineages = await PostService.getSituationData({
        plot: "topPangolinLineages",
        startDate: "2021-01-01",
        endDate: today
      })
      store.datasets.topPangolinLineages = _.map(store.datasets.topPangolinLineages, 'pangolin_lineage')


      console.log('Top pangolin lineages in store', store.datasets.topPangolinLineages)
      console.log('All pangolin lineages in store', store.constants.pangolinLineages)
      store.constants.pangolinLineageCounts = await PostService.getStat("pangolin_lineages")
      console.log(store.constants.pangolinLineageCounts)
      console.log(_.filter(_.map(_.sortBy(store.constants.pangolinLineageCounts, d => { return -1*d.count }), "lineage"), o => { return o != "None" }))
      store.constants.pangolinLineages = _.filter(_.map(_.sortBy(store.constants.pangolinLineageCounts, d => { return -1*d.count }), "lineage"), o => { return o != "None" })

      store.render.methods.loadComponent('SituationPangolinLineageSelect')
      store.render.methods.loadComponent('SituationCladeMovingAverageTimeline')

      store.methods.loadHomePage()
    },

    loadHomePage: async function() {
      if (store.debug) {
        console.log("Loading Home Page!")
      }
      
      setTimeout(() => { store.render.methods.loadComponent("NumGenomesStat") }, 100)
      setTimeout(() => { store.render.methods.loadComponent("NumVariantsStat") }, 100)
      setTimeout(() => { store.render.methods.loadComponent("NumStatesStat") }, 200)
      setTimeout(() => { store.render.methods.loadComponent("NumLabsStat") }, 200)
      setTimeout(() => { store.render.methods.loadComponent("NumCladesStat") }, 500)
      setTimeout(() => { store.render.methods.loadComponent("Homepage") }, 600)

      setTimeout(() => { store.render.methods.loadComponent("HomeDateRangePicker") }, 900)
      setTimeout(() => { store.render.methods.loadComponent("HomePangolinLineageSelect") }, 900)
      setTimeout(() => { store.render.methods.loadComponent("HomeRecentGenomesStateDistribution") }, 1000)
      setTimeout(() => { store.render.methods.loadComponent("HomeRecentGenomesSampleDemographics") }, 1200)
      setTimeout(() => { store.render.methods.loadComponent("HomeCladeDistributionTimeline") }, 1500)
      setTimeout(() => { store.render.methods.loadComponent("HomeRecentGenomesVOCStats") }, 1800)
    },

    loadImportantVariantsData: async function(caller) {
    },

    loadAcknowledgements: function (caller) {
      if (store.debug) {
        console.log(`${caller}`)
      }

      d3.text("./data/acknowledgements.txt").then(data => {
        store.datasets.labs = data.split("\n")
      })
    },

    zoomDateFilter: function (value, caller) {
      if (store.debug) {
        console.log(`${caller}`)
      }

      const diff = store.constants.dateRange[1] - store.constants.dateRange[0]
      const start = Math.round(store.constants.dateRange[0] + (diff * value.start) / 100)
      const end = Math.round(store.constants.dateRange[0] + (diff * value.end) / 100)
      store.datasets.filteredData = _.filter(store.datasets.metadata, d => {
        const date = Date.parse(d.date.split("-").join("/"))
        return (date >= start) && (date <= end);
      })
    },

    cladeColorDefault: function() {
      store.theme.colors.nextstrain_clades = store.theme.colors.nextstrain_clades_default
    }
  },

  reinfectionCaseModal: {
    visible: false,
    caseNum: 0,
    title: "Case 0",
    caseData: {},
    openModal: function(index) {
      const caseData = store.datasets.reinfection[index]
      store.reinfectionCaseModal.visible = true
      store.reinfectionCaseModal.caseData = caseData
      store.reinfectionCaseModal.caseNum = caseData.Case
      store.reinfectionCaseModal.title = `Case ${caseData.Case}`
    },
    closeModal: function() {
      console.log("Closing Modal!")
      store.reinfectionCaseModal.visible = false
    },
    navCase: function(dir) {
      if (dir === "N") {
        if (store.reinfectionCaseModal.caseNum === store.datasets.reinfection.length) {
          console.log("This is the last case!")
        } else {
          store.reinfectionCaseModal.caseNum = parseInt(store.reinfectionCaseModal.caseNum) + 1
          const caseData = store.datasets.reinfection[store.reinfectionCaseModal.caseNum - 1]
          store.reinfectionCaseModal.visible = true
          store.reinfectionCaseModal.caseData = caseData
          store.reinfectionCaseModal.title = `Case ${caseData.Case}`
        }
      }

      else if (dir === "P") {
        if (store.reinfectionCaseModal.caseNum === 1) {
          console.log("This is the first case!")
        } else {
          store.reinfectionCaseModal.caseNum =  parseInt(store.reinfectionCaseModal.caseNum) - 1
          const caseData = store.datasets.reinfection[store.reinfectionCaseModal.caseNum - 1]
          store.reinfectionCaseModal.visible = true
          store.reinfectionCaseModal.caseData = caseData
          store.reinfectionCaseModal.title = `Case ${caseData.Case}`
        }
      }
      console.log(store.reinfectionCaseModal.caseNum)
    }
  },

  mutationComponent: {

    tableSettings: {
      query: {
        pageSize: 20,
        page: 1
      },
      sort: {
        key: "percent",
        order: -1
      },
      columns: [
        {
          title: "S.no",
          key: "index",
          type: "number",
          sort: "none"
        },
        {
          title: "Gene",
          key: "gene",
          type: "string",
          sort: "none"
        },
        {
          title: "Position",
          key: "position",
          type: "number",
          sort: "none"
        },
        {
          title: "Ref AA",
          key: "ref",
          type: "string",
          sort: "none"
        },
        {
          title: "Alt AA",
          key: "alt",
          type: "string",
          sort: "none"
        },
        {
          title: "Percentage",
          key: "percent",
          type: "number",
          sort: "desc"
        },
      ],
      tableData: [],
      totalEntries: 0,
      genes: [],
      aaFeatures: [],
      featureAAPositions_all: {},
      featureAAPositions_selected: [],
    },

    tableFilters: {
      startPosition: 1,
      endPosition: 29903,
      genes: [],
      aaPosition: "",
      positionFilterType: { genomic: false, gene: true, aa: false },
      percentSliderRange: [0, 100],
    },

    variantModal: {
      selectedVariant: {},
      samplesData: {},
      show: false
    },

    variantData: {
      selectedVariant: {},
      totalCladeCounts: {},
      sampleDemographicsData: [],
      cladeTimelineScatterData: [],
      geomapTimelineData: {},
      commonCoVariantsData: [],
      showGeomapTimelinePlot: false,
      showCommonCovariantsPlot: false,
      showSampleDemographicsPlot: false,
      showCladeDistributionPlot: false,
      firstInstance: "",
    },

    methods: {

      initialiseTable: async function() {
        const context = store.mutationComponent.tableSettings
        context.query = { page: 1, pageSize: 20 }
        context.sort = { key: "percent", order: -1 }
        const query = context.query
        const sort = context.sort
        const result = await PostService.getMutationPosts(query, sort, true)
        const initialData = result.initialData[0]
        
        // const feature_data = _.map(initialData.gene, d => { return d.split(":") })
        // const features = _.uniq(_.map(feature_data, d => { return d[0] }))
        // features.sort()
        // const feature_positions = {}
        // features.forEach(f => {
        //   feature_positions[f] = _.uniq(_.map(_.filter(feature_data, d => { return d[0] === f; }), d => { return parseInt(d[1]) }))
        //   feature_positions[f].sort((a,b) => { return a-b })
        // })
        context.genes = _.map(_.filter(store.datasets.genomeFeatures, f => { return f.feature !== "gap" }),
                              o => { return { name: o.feature } })
        
        store.mutationComponent.tableFilters.genes = _.map(_.filter(store.datasets.genomeFeatures, f => { return f.feature !== "gap" }), "feature")
        // store.mutationComponent.tableFilters.startPosition = 1
        // store.mutationComponent.tableFilters.endPosition = store.constants.genomeSize
        // store.mutationComponent.tableFilters.aaPosition = ""
        // store.mutationComponent.tableFilters.percentSliderRange = [0, 100]

        context.totalEntries = result.count
        context.tableData = _.map(result.tableData, (d,i) => {
          d.index = ((context.query.page - 1) * context.query.pageSize) + i + 1
          return d
        })

        store.render.methods.loadComponent('MutationsTable')
      },

      applyFilters: async function() {
        console.log("Variants table filters applied")
        const context = store.mutationComponent.tableSettings

        context.query = {
          page: 1,
          pageSize: context.query.pageSize
        }
        context.query.gene = store.mutationComponent.tableFilters.genes
        const query = context.query
        const sort = context.sort

        const result = await PostService.getMutationPosts(query, sort)
        context.totalEntries = result.count
        context.tableData = _.map(result.tableData, (d,i) => {
          d.index = ((context.query.page - 1) * context.query.pageSize) + i + 1
          return d
        })
      },

      downloadTable: async function() {
        console.log("Variants table filters applied")
        const context = store.mutationComponent.tableSettings

        const download_query = {}
        for (let key in context.query) {
          download_query[key] = context.query[key]
        }

        download_query.page = 1
        download_query.pageSize = store.constants.numVariants + 1

        download_query.gene = store.mutationComponent.tableFilters.genes
        const download_sort = context.sort
        
        const result = await PostService.getMutationPosts(download_query, download_sort)
        const tableData = _.map(result.tableData, (d,i) => {
          d.index = ((download_query.page - 1) * download_query.pageSize) + i + 1
          return d
        })

        const delimiter = "\t"
        const columns = _.map(store.mutationComponent.tableSettings.columns, 'key')
        const content = [columns.join(delimiter)]

        tableData.forEach( d => {
          const row = []
          columns.forEach(c => { row.push(JSON.stringify(d[c])) })
          content.push(row.join(delimiter))
        })
        downloadTSV(content.join('\n'), 'Gear19_Variantstable.tsv')
      },
      
      sortTable: async function(col) {
        const context = store.mutationComponent.tableSettings

        const colIndex = _.findIndex(context.columns, { key: col })
        context.columns[colIndex].sort = store.settings.sortMap[context.columns[colIndex].sort]
        context.columns = _.map(context.columns, (d, i) => {
          if ( i !== colIndex) { d.sort = "none" }
          return d
        })
        
        if (context.columns[colIndex].sort === "none") {
          context.sort = 0
        } 
        else {
          context.sort = {}
          context.sort.key = context.columns[colIndex].key
          context.sort.order = (context.columns[colIndex].sort === "asc") ? 1 : -1
        }
        context.query.page = 1
        const query = context.query
        const sort = context.sort
        const result = await PostService.getMutationPosts(query, sort)
        context.totalEntries = result.count
        context.tableData = _.map(result.tableData, (d,i) => {
          d.index = ((context.query.page - 1) * context.query.pageSize) + i + 1
          return d
        })
      },

      handlePageChange: async function () {
        const context = store.mutationComponent.tableSettings
        const query = context.query
        const sort = context.sort
        console.log(query)
        const result = await PostService.getMutationPosts(query, sort)
        context.totalEntries = result.count
        context.tableData = _.map(result.tableData, (d,i) => {
          d.index = ((context.query.page - 1) * context.query.pageSize) + i + 1
          return d
        })
      },

      positionFilterCheck: function(type) {
        const context = store.mutationComponent.tableFilters
        if (context.positionFilterType[type]) {
          Object.keys(context.positionFilterType).forEach(k => {
            if (k !== type) { context.positionFilterType[k] = false }
          })
        }
      },

      positionFilterControl: function(type) {
        const context = store.mutationComponent.tableFilters
        Object.keys(context.positionFilterType).forEach(k => {
          if (k !== type) { context.positionFilterType[k] = false }
          else { context.positionFilterType[k] = true }
        })
      },

      selectRow: async function (caller, val) {
        if (store.debug) {
          console.log(caller)
        }
        const context = store.mutationComponent
        context.variantData.showGeomapTimelinePlot = false
        context.variantData.showCommonCovariantsPlot = false
        context.variantData.selectedVariant = val
        
        const variantData = await PostService.getMutationData(val._id)
        const geomapTimelineData = await PostService.getPlotData('variantSpecificData', { variant: `${val.ref}${val.position}${val.alt}` })

        
        context.variantData.commonCoVariantsData = variantData.commonCoVariantsData
        context.variantData.geomapTimelineData = geomapTimelineData
        // context.variantData.sampleDemographicsData = variantData.sampleDemographicsData
        // context.variantData.cladeTimelineScatterData = variantData.cladeTimelineScatterData
        
        context.variantData.showGeomapTimelinePlot = true
        setTimeout(() => { context.variantData.showCommonCovariantsPlot = true }, 500) 
      },

      dataZoomFilter: function(start, stop) {
        if (store.debug) {
          console.log("Data Zoom filter called from Genome Plot! Updating Variants table!")
        }
        const context = store.mutationComponent
        context.filters.startPosition = start
        context.filters.endPosition = stop
        context.methods.updateTable()
      },
      
      positionInputFilter: function() {
        if (store.debug) {
          console.log("Position input filter applied!")
        }
        const context = store.mutationComponent
        context.methods.triggerZoom("position filter", {
          feature: "position",
          start: context.filters.startPosition,
          stop: context.filters.endPosition
        })
      },

      featureSelectCallback: function(selectedFeature) {
        if (store.debug) {
          console.log(`Selected feature: ${selectedFeature}! Updating Variants table and Genome plot!`)
        }
        const context = store.mutationComponent
        context.filters.selectedFeature = selectedFeature
        let feature
        if (selectedFeature === "All" || selectedFeature === "gap") {
          feature = { feature: "All", start: 1, stop: store.constants.genomeSize }
          context.filters.startPosition = 1
          context.filters.endPosition = parseInt(store.constants.genomeSize)
        }
        else {
          feature = _.filter(store.datasets.genomeFeatures, d => { return d.feature === selectedFeature })[0]
          context.filters.startPosition = parseInt(feature.start)
          context.filters.endPosition = parseInt(feature.stop)
        }
        context.methods.triggerZoom("feature selection", feature)
      },

      triggerZoom(caller, feature) {
        if (store.debug) {
          console.log(`Triggered Zoom on Genome plot by ${caller}!`)
        }
        const context = store.mutationComponent

        const element = document.getElementById("mutation-chart")
        const instance = echarts.getInstanceByDom(element)
        
        const start = context.tableFilters.startPosition
        const end = context.tableFilters.endPosition
        const size = end - start
        const genomeSize = store.constants.genomeSize
        let startPercent, endPercent
        if (feature.feature === "position") {
          startPercent = (start/genomeSize)*100
          endPercent = (end/genomeSize)*100
        } else {
          startPercent = (((start-(0.05*size))/genomeSize)*100 < 0) ? 0 : ((start-(0.05*size))/genomeSize)*100
          endPercent = (((end+(0.05*size))/genomeSize)*100 > 100) ? 100 : ((end+(0.05*size))/genomeSize)*100
        }
        instance.dispatchAction({ type: "dataZoom", start: startPercent, end: endPercent, feature: feature})
      },
      
    },


  },

  metadataTable: {
    tableSettings: {
      query: { 
        page: 1,
        pageSize: 20
      },
      sort: {
        key: "accesssion",
        order: 1,
      },
      columns: [
        {
          title: "S.no",
          key: "index",
          type: "string",
          show: true, 
          sort: "none"
        },
        {
          title: "Accession",
          key: "accession",
          type: "string",
          show: true, 
          sort: "asc"
        },
        {
          title: "Strain",
          key: "strain",
          type: "string",
          show: true, 
          sort: "none"
        },
        {
          title: "Collection Date",
          key: "date",
          type: "date",
          show: true, 
          sort: "none"
        },
        {
          title: "Division",
          key: "division",
          type: "string",
          show: true, 
          sort: "none"
        },
        {
          title: "Region",
          key: "region",
          type: "string",
          show: true, 
          sort: "none"
        },
        {
          title: "Age",
          key: "age",
          type: "number",
          show: true, 
          sort: "none"
        },
        {
          title: "Gender",
          key: "gender",
          type: "string",
          show: true, 
          sort: "none"
        },
        {
          title: "Clade",
          key: "nextstrain_clade",
          type: "string",
          show: true, 
          sort: "none"
        },
        {
          title: "Old Nextstrain Clade",
          key: "clade",
          type: "string",
          show: true, 
          sort: "none"
        },
        {
          title: "Pangolin Lineage",
          key: "pangolin_lineage",
          type: "string",
          show: true, 
          sort: "none"
        },
        {
          title: "GISAID Clade",
          key: "gisaid_clade",
          type: "string",
          show: true, 
          sort: "none"
        },
        {
          title: "Sequence N (%)",
          key: "n_percent",
          type: "number",
          show: true, 
          sort: "none"
        },
        {
          title: "Sequence Gap (%)",
          key: "gap_percent",
          type: "number",
          show: true, 
          sort: "none"
        },
        {
          title: "Submitting lab",
          key: "submitter",
          type: "string",
          show: false, 
          sort: "none"
        },
      ],
      tableData: [],
      tableDataCurrentPage: [],
      show: true
    },
    plotData: {
      cladeTimelineScatterData: [],
      sampleDemographicsData: [],
      stateContributionBarData: [],
      geomapTimelineData: {},
      mostFrequentVariantsData: [],
    },
    tableFilters: {
      cladeCheck: false,
      genderCheck: false,
      ageCheck: false,
      dateCheck: false,
      divisionCheck: false,
      nCheck: false,
      gapCheck: false,
      cladeFilterType: "nextstrain_clade",
      minAge: 0,
      maxAge: 0,
      clade: [],
      nextstrain_clade: [],
      gisaid_clade: [],
      gender: [],
      division: [],
      n_percent: 0,
      gap_percent: 0,
      collectionDate_start: 0,
      collectionDate_end: 0,
    },
    methods: {
      initialiseTable: async function () {
        const context = store.metadataTable.tableSettings
        const query = context.query
        const sort = context.sort
        const result = await PostService.getGenomePosts(query, sort, true)

        store.metadataTable.plotData.cladeTimelineScatterData = result.cladeTimelineScatterData
        store.metadataTable.plotData.sampleDemographicsData = result.sampleDemographicsData
        store.metadataTable.plotData.stateContributionBarData = result.stateContributionBarData
        store.metadataTable.plotData.geomapTimelineData = result.geomapTimelineData[0]
        store.metadataTable.plotData.mostFrequentVariantsData = result.genomesMostFrequentVariantsData

        const initialData = result.initialData[0]
        const ages = _.filter(initialData.age, a => { return a !== "Unknown" })
        store.constants.minAge = _.min(ages)
        store.metadataTable.tableFilters.minAge = store.constants.minAge
        store.constants.maxAge = _.max(ages)
        store.metadataTable.tableFilters.maxAge = store.constants.maxAge

        initialData.clades.sort()
        initialData.nextstrain_clades.sort()
        initialData.gisaid_clades.sort()
        initialData.pangolin_lineage.sort()
        initialData.genders.sort()
        initialData.states.sort()
        store.constants.clades = initialData.clades
        store.constants.nextstrain_clades = initialData.nextstrain_clades
        store.constants.gisaid_clades = initialData.gisaid_clades
        store.constants.pangolin_lineage = initialData.pangolin_lineage
        store.constants.gender = initialData.genders
        store.metadataTable.tableFilters.gender = initialData.genders
        store.metadataTable.tableFilters.clade = initialData.clades
        store.metadataTable.tableFilters.nextstrain_clade = initialData.nextstrain_clades
        store.metadataTable.tableFilters.gisaid_clade = initialData.gisaid_clades
        store.metadataTable.tableFilters.pangolin_lineage = initialData.pangolin_lineage
        initialData.states.splice(initialData.states.indexOf("India"), 1)
        store.metadataTable.tableFilters.division = initialData.states

        const dates = _.map(initialData.dates, d => {
          const date = d.split("-").join("/")
          return Date.parse(date)
        })
        store.metadataTable.tableFilters.collectionDate_start = _.min(dates)
        store.metadataTable.tableFilters.collectionDate_end = _.max(dates)

        
        store.metadataTable.tableFilters.n_percent = initialData.n_percent
        store.constants.n_percent = initialData.n_percent
        store.metadataTable.tableFilters.gap_percent = initialData.gap_percent
        store.constants.gap_percent = initialData.gap_percent

        context.totalEntries = result.count
        context.tableData = _.map(result.tableData, (d,i) => {
          d.index = ((context.query.page - 1) * context.query.pageSize) + i + 1
          return d
        })


        setTimeout(() => { store.render.methods.loadComponent("GenomesMetadataTable") }, 300)
        setTimeout(() => { store.render.methods.loadComponent("GenomesGeomapTimeline") }, 500)
        setTimeout(() => { store.render.methods.loadComponent("GenomesSampleDemographics") }, 1500)
      },
      resetFilters: async function() {
        const context = store.metadataTable.tableSettings
        context.query = { page: 1, pageSize: 20 }
        context.sort = { key: "accesssion", order: 1 },
        store.metadataTable.methods.initialiseTable()
      },
      handlePageChange: async function () {
        const context = store.metadataTable.tableSettings
        const query = context.query
        const sort = context.sort
        const result = await PostService.getGenomePosts(query, sort)
        context.totalEntries = result.count
        context.tableData = _.map(result.tableData, (d,i) => {
          d.index = ((context.query.page - 1) * context.query.pageSize) + i + 1
          return d
        })
      },
      sortTable: async function(col) {
        const context = store.metadataTable.tableSettings

        const colIndex = _.findIndex(context.columns, { key: col })
        context.columns[colIndex].sort = store.settings.sortMap[context.columns[colIndex].sort]
        context.columns = _.map(context.columns, (d, i) => {
          if ( i !== colIndex) { d.sort = "none" }
          return d
        })
        
        if (context.columns[colIndex].sort === "none") {
          context.sort = 0
        } 
        else {
          context.sort = {}
          context.sort.key = context.columns[colIndex].key
          context.sort.order = (context.columns[colIndex].sort === "asc") ? 1 : -1
        }
        context.query.page = 1
        const query = context.query
        const sort = context.sort
        const result = await PostService.getGenomePosts(query, sort)
        context.totalEntries = result.count
        context.tableData = _.map(result.tableData, (d,i) => {
          d.index = ((context.query.page - 1) * context.query.pageSize) + i + 1
          return d
        })
      },
      applyFilters: async function() {
        console.log("Metadata table filters applied")
        const context = store.metadataTable.tableSettings
        if (store.metadataTable.tableFilters.ageCheck) {
          context.query.age = [store.metadataTable.tableFilters.minAge, store.metadataTable.tableFilters.maxAge]
        }

        if (store.metadataTable.tableFilters.genderCheck) {
          context.query.gender = store.metadataTable.tableFilters.gender
        }

        if (store.metadataTable.tableFilters.divisionCheck) {
          context.query.division = store.metadataTable.tableFilters.division
        }

        if (store.metadataTable.tableFilters.nCheck) {
          context.query.n_percent = store.metadataTable.tableFilters.n_percent
        }

        if (store.metadataTable.tableFilters.gapCheck) {
          context.query.gap_percent = store.metadataTable.tableFilters.gap_percent
        }

        if (store.metadataTable.tableFilters.dateCheck) {
          const start_date = new Date(store.metadataTable.tableFilters.collectionDate_start)
          const mm1 = ((start_date.getMonth() + 1) < 10) ? `0${(start_date.getMonth() + 1)}` : (start_date.getMonth() + 1)
          const dd1 = (start_date.getDate() < 10) ? `0${start_date.getDate()}` : start_date.getDate()
          const yy1 = start_date.getFullYear()
          const end_date = new Date(store.metadataTable.tableFilters.collectionDate_end)
          const mm2 = ((end_date.getMonth() + 1) < 10) ? `0${(end_date.getMonth() + 1)}` : (end_date.getMonth() + 1)
          const dd2 = (end_date.getDate() < 10) ? `0${end_date.getDate()}` : end_date.getDate()
          const yy2 = end_date.getFullYear()
          context.query.date = [`${yy1}-${mm1}-${dd1}`, `${yy2}-${mm2}-${dd2}`]
        }

        if (store.metadataTable.tableFilters.cladeCheck) {
          if (store.metadataTable.tableFilters.cladeFilterType === "nextstrain_clade") {
            context.query.nextstrain_clade = store.metadataTable.tableFilters.nextstrain_clade
          }
          else if (store.metadataTable.tableFilters.cladeFilterType === "gisaid_clade") {
            context.query.gisaid_clade = store.metadataTable.tableFilters.gisaid_clade
          }
          else if (store.metadataTable.tableFilters.cladeFilterType === "pangolin_lineage") {
            context.query.pangolin_lineage = store.metadataTable.tableFilters.pangolin_lineage
          }
        }

        context.query.page = 1
        const query = context.query
        const sort = context.sort
        const result = await PostService.getGenomePosts(query, sort)

        store.render.GenomesGeomapTimeline = false
        store.render.GenomesSampleDemographics = false
        
        store.metadataTable.plotData.sampleDemographicsData = result.sampleDemographicsData
        store.metadataTable.plotData.cladeTimelineScatterData = result.cladeTimelineScatterData
        store.metadataTable.plotData.stateContributionBarData = result.stateContributionBarData
        store.metadataTable.plotData.geomapTimelineData = result.geomapTimelineData[0]
        store.metadataTable.plotData.mostFrequentVariantsData = result.genomesMostFrequentVariantsData
        
        setTimeout(() => { store.render.methods.loadComponent("GenomesGeomapTimeline") }, 300)
        setTimeout(() => { store.render.methods.loadComponent("GenomesSampleDemographics") }, 500)

        context.totalEntries = result.count
        context.tableData = _.map(result.tableData, (d,i) => {
          d.index = ((context.query.page - 1) * context.query.pageSize) + i + 1
          return d
        })
      }
    },
  },

  statesPage: {
    devState: "",
    selectState: '',
    selectedState: '',
    stateDataLoading: true,
    datasets: {
      cladeData: [],
      mutationData: []
    },
    cladeFilter: "nextstrain_clade",
    metadata: [],
    filteredMetadata: [],
    plotData: [],
    cladeDist: [],
    variants: [],
    timeLine: [],
    districtsCounts: [],
    methods:{
      selectState: async function(val)  {
        store.statesPage.selectedState = val
        store.statesPage.stateDataLoading = true
        const data = await PostService.getStateData(val)
        store.statesPage.datasets.cladeData = data.cladeData
        store.statesPage.datasets.mutationData = data.mutationData
        store.statesPage.stateDataLoading = false
      },
      filterStateNames(){
        store.statesPage.filteredMetadata = store.statesPage.metadata.filter(data => data.division == store.statesPage.selectState)
      },
      setSeries(data){
        console.log("yup, i work")
        store.statesPage.plotData = data
      }, 
      setBorder(switcher){
        if(switcher) store.statesPage.devState = "border: 1px dashed black; background-color: hsla(312, 50%, 96%, 0.363);"
        else store.statesPage.devState = ""
      },
      objcmp(obj1, obj2){ //method to brute force compare objects
        let keys1 = Object.keys(obj1)
        let keys2 = Object.keys(obj2)
        if(keys1.length !== keys2.length) return false
        else for(let key of keys1)
            if(obj1[key] !== obj2[key]) return false
        return true
      },
      cladePieData(filter){
        let dat =  store.statesPage.filteredMetadata.map( val => _.omit(val, ["variants"]))
        dat = dat.map( val =>_.pick(val, [filter]))
        let unique = _.uniqBy(dat, filter)
        
        return unique.map(val => {
            let sum = 0 
            dat.forEach(v => {if(this.objcmp(v, val)) sum+=1})
            return {"value": sum, "name": val[filter]}
        })
      },
      filterVariants(){
        let data = store.statesPage.filteredMetadata.map(val => _.pick(val, "variants"))
        data = data.map(value => value["variants"])
        data = data.flat()

        let model ={
            position: null,
            ref: null,
            alt: null,
            gene: null,
            aaVar: null,
        }
        // !removing unnecesary keys
        let dataClean = data.map(value => _.pick(value, _.keys(model)))
        let data2 = dataClean

        //! determining uique mutations
        var result = _.uniqBy(data2, v => [v.position, v.ref, v.alt, v.gene, v.aaVar].join());

        //! determining counts of uique mutations and adding to the unique json list
        result.map(val => {
            let sum = 0 
            data2.forEach(v => {if(this.objcmp(v, val)) sum+=1})
            Object.assign(val, {numbers: sum})
        })
        store.statesPage.variants = result
        return result
      },
      setDistricts(){
        // store.statesPage.districtsCounts
        let filter = "Hyderabad"
        let dat =  store.statesPage.filteredMetadata.map( val => _.omit(val, ["variants"]))
        dat = dat.map( val =>_.pick(val, [filter]))
        let unique = _.uniqBy(dat, filter)
        
        return unique.map(val => {
            let sum = 0 
            dat.forEach(v => {if(this.objcmp(v, val)) sum+=1}) 
            return {"name": filter, "value": sum}
        })
      },
      timeLineClade(){
        let selectClade = store.statesPage.cladeFilter
        //determine list of clades
        let clades =_.uniq(_.map(store.statesPage.filteredMetadata.map(val => _.pick(val, selectClade)), selectClade))
        let finData = []
        for(let clade of clades){
          let data = store.statesPage.filteredMetadata.filter(val => val[selectClade] === clade) //filter out each clade
          let sortArr = _.sortBy(data.map(val => _.pick(val, [selectClade, 'date'])), 'date')    //sort data based on date
          let counts = _.uniqBy(sortArr, 'date')
          let tmpArr = { 
            name: clade,
            type: 'line',
            // smooth: 0.6,
            symbol: 'none',
            areaStyle: {},
            data: []
          }

          tmpArr.data = counts.map(val => {
            let sum = 0
            sortArr.forEach(v => {if(this.objcmp(v, val)) sum+=1})
            return [val.date ,sum]  //repackaging data to array 
          })                  
          finData.push(tmpArr)
        }
        store.statesPage.timeLine = finData
        return finData
      }
    }
  },

  modal: {
    visible: false,
    component: "",
    openModal(val) {
      store.modal.visible = true
      store.modal.component = val
    },
    title: {
      SettingsPanel: "Application settings"
    }
  }
}

export {
  store
};